import React, { useCallback, useEffect } from 'react';
import { Box, Container, makeStyles } from '@material-ui/core';
import { LoaderBar, Page } from 'src/components';
import { GalleyListToolbar } from './Toolbar';
import { slices, useAppDispatch, useAppSelector } from 'src/redux';
import { GalleyListTable } from './GalleyListTable';
import { useIsMount } from 'src/hooks';
import { Pagination } from '@material-ui/lab';
import { GalleryGetRequest } from 'src/types';

const { selectors: gallerySelectors, actions: galleryActions } = slices.gallery;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  galleryCard: {
    height: '100%'
  }
}));

export const GalleryListView = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const isFirstMount = useIsMount();

  const isLoading = useAppSelector(gallerySelectors.selectIsListLoading);
  const paginationMeta = useAppSelector(
    gallerySelectors.selectGalleryPaginationMeta
  );

  const getGallery = useCallback(
    async (request?: GalleryGetRequest) =>
      dispatch(galleryActions.getGalleryListThunk(request || {})),
    [dispatch]
  );

  useEffect(() => {
    if (isFirstMount) {
      getGallery();
    }
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page className={classes.root} title="Builds Gallery List">
      <Container maxWidth={false}>
        <GalleyListToolbar />
        <Box mt={2}>
          <LoaderBar isLoading={isLoading} />
          <GalleyListTable />
        </Box>
      </Container>
      <Box display="flex" justifyContent="flex-end" p={2}>
        <Pagination
          count={paginationMeta?.last_page || 1}
          page={paginationMeta?.current_page || 1}
          onChange={(e, p) => getGallery({ page: p })}
        />
      </Box>
    </Page>
  );
};
